module.exports = __webpack_public_path__ + "fa-brands-400.30cc681d4487d2f56103.eot";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/plugins/fontawesome-free/webfonts/fa-brands-400.eot
// module id = ../../../../../src/assets/plugins/fontawesome-free/webfonts/fa-brands-400.eot
// module chunks = styles